import { FormattedNumber } from 'react-intl';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { EssenceBalance } from '@sorare/core/src/components/balance/EssenceBalance/index.tsx';
import { InGameCurrencyBalance } from '@sorare/core/src/components/balance/InGameCurrencyBalance/index.tsx';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser/index.ts';
import { inGameCurrencyToRarity } from '@sorare/core/src/lib/scarcity.ts';

type Props = {
  rarity: Rarity;
};

export const ProMissionsRarityBalances = ({ rarity }: Props) => {
  const { currentUser } = useCurrentUserContext();
  const xpBalance = currentUser?.xpBalances?.find(
    ({ currency }) => inGameCurrencyToRarity[currency] === rarity
  );
  const shardsValue =
    currentUser?.cardShardsChests
      ?.filter(chest => chest.rarity === rarity)
      .reduce((sum, chest) => sum + chest.cardShardsCount, 0) ?? 0;

  return (
    <Horizontal>
      {!!xpBalance && (
        <InGameCurrencyBalance
          currency={xpBalance.currency}
          amount={
            <FormattedNumber value={xpBalance.amount} notation="compact" />
          }
        />
      )}
      <EssenceBalance rarity={rarity} value={shardsValue} />
    </Horizontal>
  );
};
